/**
 * 보고서 유형 표시 메타 — 유형 타일 색.
 * 결재함·문서관리 등 유형 타일을 그리는 화면이 공유한다(중복 정의 금지).
 *
 * ⚠️ 타일 색 맵은 **exhaustive `Record<BadgeTone, …>`를 유지할 것** — tone이 늘 때 tsc가 누락을
 * 잡는다. 유형별 픽토그램 맵은 두지 않는다 — 호출부가 기본 문서 아이콘(`DocumentIcon`)을 직접
 * import한다. 양식별로 픽토그램을 가르고 싶다면 그건 유형 축이 아니라 양식(templateKey) 축의 일이다.
 */
import type { BadgeTone } from '@safetyhub/ui';

/**
 * 유형 아이콘 타일 색 — 목업 `.appr-ic` 4색. Badge tone과 같은 축을 쓰되
 * 타일은 ring 없이 연배경 + 본색이라 별도 리터럴 맵으로 둔다(Tailwind 정적 스캔).
 * `Record<BadgeTone, string>`이라 tone이 늘면 tsc가 누락을 잡는다.
 */
export const REPORT_TYPE_TILE_CLASS: Record<BadgeTone, string> = {
  blue: 'bg-blue-50 text-blue-600',
  emerald: 'bg-emerald-50 text-emerald-600',
  amber: 'bg-amber-50 text-amber-600',
  orange: 'bg-orange-50 text-orange-600',
  rose: 'bg-rose-50 text-rose-600',
  violet: 'bg-violet-50 text-violet-600',
  teal: 'bg-teal-50 text-teal-600',
  slate: 'bg-ink-100 text-ink-500',
  brand: 'bg-brand-50 text-brand-700',
};

/**
 * 유형 타일 색 안전 조회 — tone이 없으면 중립 slate.
 * 표시 계층은 모르는 값을 만나도 **죽지 않고 기본**으로 떨어지는 게 맞다(2026-07-27 결재함이
 * 맵 직접 인덱싱의 `undefined`로 페이지째 죽은 전례).
 */
export function getReportTypeTileClass(tone: BadgeTone | undefined): string {
  return (tone && REPORT_TYPE_TILE_CLASS[tone]) || REPORT_TYPE_TILE_CLASS.slate;
}
